import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextField, Text, Stack, DefaultButton, Separator } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getAccountSelectorStyle } from './styles';

const errorTextStyle = { root: { color: 'red' } };

const ErrorDescription = (props) => {
  const { description } = props;
  return (
    <Text variant="small" styles={errorTextStyle}>
      {description}
    </Text>
  );
};

ErrorDescription.propTypes = {
  description: PropTypes.string,
};

ErrorDescription.defaultProps = {
  description: '',
};

function isUserIdValid(userId) {
  const isNumberic = !isNaN(userId);
  const isNotEmptyString = userId !== '';
  return isNumberic && isNotEmptyString;
}

function getUserIdErrorDescription(userId, i18n) {
  // string `userId` is not numeric
  if (isNaN(userId)) {
    return i18n.getString(_TL_('Field requires numeric value'));
  }
  if (userId === '') {
    return i18n.getString(_TL_('Required field'));
  }
  return '';
}

function UserScopeInput(props) {
  const {
    userId,
    onApplyClick: onApply,
    onCancelClick: onCancel,
    isSeparatorBeforeButtons,
    applyText,
    className,
  } = props;
  const [currentUserIdString, setCurrentUserIdString] = useState(userId && userId.toString());

  const i18n = useContext(I18nContext);
  const isValueValid = isUserIdValid(currentUserIdString);
  const descriptionText = getUserIdErrorDescription(currentUserIdString, i18n);

  const classes = useDefaultStyles(getAccountSelectorStyle);

  function onApplyClick() {
    if (!isUserIdValid(currentUserIdString)) {
      throw new Error('when click save, current user ID must be valid(numeric).');
    }
    onApply(parseInt(currentUserIdString, 10));
  }

  function onCancelClick() {
    onCancel();
  }

  function onUserIDTextChange(event, newValue) {
    setCurrentUserIdString(newValue);
  }

  return (
    <div className={`${classes.userInputScope} ${className}`}>
      <TextField
        label={i18n.getString(_TL_('User ID'))}
        // onRenderLabel={onRenderLabel}
        value={currentUserIdString}
        onChange={onUserIDTextChange}
        description={descriptionText}
        onRenderDescription={ErrorDescription}
      />
      {isSeparatorBeforeButtons && <Separator />}
      <Stack horizontal className="actions">
        {
          onApply && <DefaultButton primary className="apply" text={applyText || i18n.getString(_TL_('Apply'))} onClick={onApplyClick} disabled={!isValueValid} />
        }
        {
          onCancel && <DefaultButton className="cancel" text={i18n.getString(_TL_('Cancel'))} onClick={onCancelClick} />
        }
      </Stack>
    </div>
  );
}

UserScopeInput.propTypes = {
  userId: PropTypes.number.isRequired,
  onApplyClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isSeparatorBeforeButtons: PropTypes.bool.isRequired,
  applyText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

UserScopeInput.defaultProps = {
  className: '',
};

export { UserScopeInput };
